export const BASE_URL = 'monitoring';

export const PATHS = {
  BASE_URL,
  LOCATION_ALERTS: `${BASE_URL}/locationAlerts`,
  LOCATION_ALERT_DETAILS: `${BASE_URL}/locationAlerts/:divId/:id`,
} as const;

export const LOCATION_ALERTS_PAGE_SIZE = 100;

export const LOCATION_ALERTS_FILTERS_STORAGE_KEY = 'locationAlertsListFilters';
export const LOCATION_ALERTS_SORT_STORAGE_KEY = 'locationAlertsTableSort';
